<template>
  <div></div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { SET_AUTHORIZED } from 'vx/mutations'
  import auth from 'utils/auth'

  export default {

    created () {
      auth.clearToken()

      this[SET_AUTHORIZED](false)
      this.$root.authenticated = false
      this.$root.user = null
      localStorage.removeItem('user')
      localStorage.removeItem('token')

      this.$root.$router.push('/auth/login')
    },

    methods: mapMutations('user', [SET_AUTHORIZED])
  }
</script>